import { gql } from '@apollo/client';

export const FILTERED_FUNDER_INSTITUTIONS = gql`
  query FilteredFunderInstitutions($input: FilterInstitutions!) {
    institutions: filteredFunderInstitutions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
